/**
 * TanStack Query hooks for `cost-etl-import-ad-network-spend-compute-net-margi`. Thin wrappers over ./api.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	listSpend,
	getMargin,
	costEtlImportAdNetworkSpendComputeNetMargiQueryKeys,
	type ListSpendResponse,
	type MarginFilters,
	type MarginResponse,
} from "./api";

export function useCostEtlImportAdNetworkSpendComputeNetMargiSpendList(): UseQueryResult<
	ListSpendResponse,
	Error
> {
	return useQuery({
		queryKey: costEtlImportAdNetworkSpendComputeNetMargiQueryKeys.spend(),
		queryFn: listSpend,
	});
}

export function useCostEtlImportAdNetworkSpendComputeNetMargiMargin(
	filters: MarginFilters = {},
): UseQueryResult<MarginResponse, Error> {
	return useQuery({
		queryKey: costEtlImportAdNetworkSpendComputeNetMargiQueryKeys.margin(filters),
		queryFn: () => getMargin(filters),
	});
}
